var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{staticClass:"spinner",attrs:{"width":_vm.props.size,"height":_vm.props.size,"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])}
var staticRenderFns = []

export { render, staticRenderFns }